export const PROGRESS_STAGE_THRESHOLDS = {
  LOW: 25,
  FULL: 100,
} as const;

export const PROGRESS_STAGE_COLORS = {
  LOW: "negative",
  IN_PROGRESS: "warning",
  COMPLETE: "primary",
} as const;

export type ProgressStageColor =
  (typeof PROGRESS_STAGE_COLORS)[keyof typeof PROGRESS_STAGE_COLORS];

export const getProgressStageColor = (
  percentage: number,
): ProgressStageColor => {
  if (percentage >= PROGRESS_STAGE_THRESHOLDS.FULL) {
    return PROGRESS_STAGE_COLORS.COMPLETE;
  }

  if (percentage < PROGRESS_STAGE_THRESHOLDS.LOW) {
    return PROGRESS_STAGE_COLORS.LOW;
  }

  return PROGRESS_STAGE_COLORS.IN_PROGRESS;
};
